import {
    Directive,
    Input,
    ElementRef,
    HostListener,
  } from "@angular/core";
  import { Sort } from "../util/sort";
  
  @Directive({
    selector: "[appSort]",
  })
  export class SortDirective {
    @Input() appSort: Array<any>;
    @Input() naSortCol: string;
    constructor(private targetElem: ElementRef) { }
  
    @HostListener('click')
    @HostListener('keydown.enter')
    sortData() {
      // Create Object of Sort Class
      const sort = new Sort();
      // Get Reference Of Current Clicked Element
      const elem = this.targetElem.nativeElement;
      // Get In WHich Order list should be sorted by default it should be set to desc on element attribute
      const order = elem.getAttribute("data-order");
      // Get The Property Type specially set [data-type=date] if it is date field
      const type = elem.getAttribute("data-type");
      // Get The Property Name from Element Attribute
      const property = elem.getAttribute("data-name");
      const secondarySortCol = elem.getAttribute("secondary-sort-col");
  
      this.appSort.sort(sort.startSort(property, order, type))
  
      // Sort data with second priority
      if (secondarySortCol) {
  
        let sortingPropertyArray = [];
        sortingPropertyArray = this.appSort.map(item => item[property]).filter((value, index, self) => self.indexOf(value) === index)
  
        let sortedArray = [];
  
        sortingPropertyArray.map(item => {
          let tempArray = this.appSort.filter(obj => obj[property] == item);
          tempArray.sort(sort.startSort(secondarySortCol, "desc", type));
          sortedArray.push(...tempArray);
        })
  
        this.appSort.splice(0);
  
        this.appSort.push(...sortedArray);
      }
      if(this.naSortCol)
    {
      debugger;
      let tempNA=this.appSort.filter(m=>m[property]===this.naSortCol);
      let notNARecord=this.appSort.filter(m=>m.currentUOGoalsLicenseStatus!==this.naSortCol);
      this.appSort.splice(0);
      if (order === "desc")
      {
         this.appSort.push(...tempNA,...notNARecord);      
      }
      if (order === "asc")
      {
        this.appSort.push(...notNARecord,...tempNA);     
      }
    }
      if (order === "desc") {
        elem.setAttribute("data-order", "asc");
        elem.classList.remove('sorted-asc');
        elem.classList.add('sorted-desc');
      } else {
        elem.setAttribute("data-order", "desc");
        elem.classList.remove('sorted-desc');
        elem.classList.add('sorted-asc');
      }
    }
  }
  